function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import SpzaComponent from './spzaComponent';
import { urlPush } from '../../shared/routerHistory';
import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { logger } from '@src/logger';
import { omit } from 'lodash-es';
export class InternalLink extends SpzaComponent {
    addHiddenFocus() {
        if (this.internalLinkElement) {
            this.internalLinkElement.classList.add('x-hidden-focus');
        }
    }
    removeHiddenFocus() {
        if (this.internalLinkElement) {
            this.internalLinkElement.classList.remove('x-hidden-focus');
        }
    }
    renderImpl() {
        const _this_props = this.props, { telemetryDetails } = _this_props, rest = _object_without_properties(_this_props, [
            "telemetryDetails"
        ]);
        let href = null;
        let onClick = null;
        let children = null;
        const aTagAccEnabled = rest.role !== 'checkbox' && rest.accEnabled ? 0 : -1;
        const otherProps = {};
        let additionalCommand = null;
        for(const p in omit(rest, 'accEnabled')){
            const val = rest[`${p}`];
            if (p === 'href') {
                href = val;
            } else if (p === 'onClick') {
                onClick = val;
            } else if (p === 'children') {
                children = val;
            } else if (p === 'additionalCommand') {
                additionalCommand = val;
            } else {
                otherProps[`${p}`] = val;
            }
        }
        let callback;
        if (onClick) {
            callback = (e)=>{
                if (additionalCommand) {
                    additionalCommand(e);
                }
                onClick(e);
                e.preventDefault();
            };
        } else {
            callback = (e)=>{
                if (additionalCommand) {
                    additionalCommand(e);
                }
                e.preventDefault();
                urlPush(href, this.props.scrollToTop);
            };
        }
        const { scrollToTop } = otherProps, domProps = _object_without_properties(otherProps, [
            "scrollToTop"
        ]);
        return /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({}, domProps), {
            href: href,
            onClick: (event)=>{
                const payload = {
                    page: getWindow().location.href,
                    action: Constants.Telemetry.Action.Click,
                    actionModifier: Constants.Telemetry.ActionModifier.InternalLink,
                    details: telemetryDetails || JSON.stringify(href)
                };
                this.provider.probe(Constants.Telemetry.ProbeName.LogInfo, payload);
                logger.info(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
                return callback(event);
            },
            tabIndex: aTagAccEnabled,
            ref: (element)=>this.internalLinkElement = element,
            onMouseDown: ()=>this.addHiddenFocus(),
            onBlur: ()=>this.removeHiddenFocus(),
            children: children
        }));
    }
    constructor(props, context){
        super(props, context), _define_property(this, "internalLinkElement", void 0), _define_property(this, "provider", void 0);
        this.provider = SpzaInstrumentService.getProvider();
        this.addHiddenFocus = this.addHiddenFocus.bind(this);
        this.removeHiddenFocus = this.removeHiddenFocus.bind(this);
    }
}
